import React from 'react';
import styles from './Spinner.module.css';

const Spinner = () => (
  <div className={styles.wrapper}>
    <div className={styles['lds-grid']}>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
);

export default Spinner;
